import { ApplicationControlModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface ApplicationControlFormValue {
  uiSettings: { applicationControl: ApplicationControlModule };
}

// searchable keywords
export enum ApplicationControlSearchableKeywords {
  ApplicationControl = 'ApplicationControl',
  TestMode = 'TestMode',
  RunInTestMode = 'RunInTestMode',
  ProcessStartRules = 'ProcessStartRules',
}
